<template>
  <div>
    <v-fade-transition
            group
            tag="div"
            hide-on-leave
    >
    <ExampleInput v-for="(example, index) in value" :key="example.id" v-model="value[index]" @remove="onRemove"></ExampleInput>
    </v-fade-transition>
    <div class="text-xs-right">
      <v-btn @click="add">Add example</v-btn>
    </div>
  </div>
</template>

<script>
import ExampleInput from './ExampleInput'
import without from 'lodash/without'

export default {
  components: { ExampleInput },
  props: ['value', 'translation'],
  data () {
    return {
      autoIncrement: -1
    }
  },
  methods: {
    nextId () {
      return this.autoIncrement--
    },
    onRemove (example) {
      this.$emit('input', without(this.value, example))
    },
    add () {
      this.$emit('input', [...this.value, { id: this.nextId() }])
    }
  }
}
</script>
